const translations = {
    "product-brief-builder": "سازنده برگه محصول",
    "pbb-page-description": "ساخت برگه محصول و Prompt برای Codex",
    "pbb-internal-tool": "ابزار داخلی تیم توسعه",
    "pbb-title": "سازنده برگه محصول",
    "pbb-description": "درخواست محصول را کامل کنید تا یک Prompt دقیق و قابل تحویل به Codex ساخته شود.",
    "pbb-step-basic": "اطلاعات پایه",
    "pbb-step-problem": "مسئله و کاربر",
    "pbb-step-scenario": "سناریو و دسترسی",
    "pbb-step-outcome": "نتیجه و معیار پذیرش",
    "pbb-step-boundaries": "مرزها و ابهام‌ها",
    "pbb-step-review": "مرور و خروجی",
    "pbb-steps": "مراحل برگه محصول",
    "pbb-step-description": "اطلاعات این مرحله را کامل کنید؛ پیش‌نمایش همزمان به‌روزرسانی می‌شود.",
    "pbb-request-type": "نوع درخواست",
    "pbb-request-new-feature": "فیچر جدید",
    "pbb-request-behavior-change": "تغییر رفتار",
    "pbb-request-ui-improvement": "بهبود UI",
    "pbb-request-bugfix": "رفع باگ",
    "pbb-feature-name": "نام فیچر یا تغییر",
    "pbb-feature-name-placeholder": "مثلاً: جلسات پروژه",
    "pbb-priority": "اولویت",
    "pbb-priority-critical": "بحرانی",
    "pbb-priority-high": "بالا",
    "pbb-priority-medium": "متوسط",
    "pbb-priority-low": "پایین",
    "pbb-involved-areas": "بخش‌های درگیر",
    "pbb-involved-areas-placeholder": "مثلاً: Project, Task, Calendar",
    "pbb-requester": "توسعه‌دهنده یا درخواست‌دهنده",
    "pbb-requester-placeholder": "نام فرد یا تیم",
    "pbb-request-date": "تاریخ ثبت",
    "pbb-codex-mode": "حالت اجرای موردنظر برای Codex",
    "pbb-mode-analysis": "تحلیل نیاز و بررسی Backend",
    "pbb-mode-frontend-after-receipt": "پیاده‌سازی Frontend بعد از Backend Receipt",
    "pbb-mode-ui-only": "فقط بهبود UI بدون تغییر Backend",
    "pbb-mode-bugfix": "بررسی و رفع باگ",
    "pbb-select-placeholder": "انتخاب کنید",
    "pbb-problem-guidance": "به‌جای «بخش جلسات را بساز»، توضیح بده کاربر چه مشکلی دارد، چه کاری می‌خواهد انجام دهد و در پایان چه نتیجه‌ای باید بگیرد.",
    "pbb-problem": "مسئله‌ای که باید حل شود",
    "pbb-target-user": "کاربر هدف",
    "pbb-target-role": "نقش کاربر هدف",
    "pbb-business-impact": "اثر یا نتیجه کسب‌وکاری مورد انتظار",
    "pbb-existing-product-relation": "ارتباط با بخش‌های فعلی محصول",
    "pbb-user-scenario": "سناریوی کاربر",
    "pbb-scenario-placeholder": "یک مرحله از سناریو را بنویسید",
    "pbb-allowed-roles": "نقش‌های مجاز",
    "pbb-denied-roles": "نقش‌های غیرمجاز",
    "pbb-role-role": "نقش",
    "pbb-role-action": "اقدام مجاز",
    "pbb-role-limitation": "محدودیت",
    "pbb-role-description": "توضیح",
    "pbb-add-role": "افزودن نقش",
    "pbb-product-location": "محل استفاده در محصول",
    "pbb-expected-outcome": "نتیجه نهایی مورد انتظار",
    "pbb-acceptance-criteria": "معیارهای پذیرش",
    "pbb-acceptance-placeholder": "یک معیار پذیرش بنویسید",
    "pbb-connected-areas": "اتصال احتمالی به بخش‌های محصول",
    "pbb-connected-areas-note": "این گزینه‌ها فقط برای کمک به تحلیل Codex هستند و Backend Contract قطعی محسوب نمی‌شوند.",
    "pbb-out-of-scope": "چیزهایی که در این مرحله نمی‌خواهیم",
    "pbb-out-of-scope-placeholder": "یک مورد خارج از Scope",
    "pbb-open-questions": "ابهام‌ها و تصمیم‌های باز",
    "pbb-open-question-placeholder": "یک پرسش یا تصمیم باز",
    "pbb-dependencies": "وابستگی‌ها یا قابلیت‌های مرتبط موجود",
    "pbb-backend-receipt-path": "مسیر Backend Receipt",
    "pbb-bcr-path": "مسیر BCR موجود",
    "pbb-known-contract": "Endpoint یا Contract شناخته‌شده",
    "pbb-extra-technical-notes": "توضیحات فنی اضافه",
    "pbb-review-ready-title": "مرور نهایی",
    "pbb-review-ready-description": "اگر اطلاعات حداقلی کامل باشد، Copy و دانلود Word فعال می‌شوند.",
    "pbb-form-valid": "فرم برای ساخت Prompt و فایل Word آماده است.",
    "pbb-error-required": "این فیلد برای خروجی نهایی لازم است.",
    "pbb-error-scenario": "حداقل یک مرحله از سناریوی کاربر لازم است.",
    "pbb-error-access": "حداقل یک نقش مجاز یا توضیح روشن برای مدل دسترسی لازم است.",
    "pbb-error-acceptance": "حداقل یک معیار پذیرش لازم است.",
    "pbb-add-item": "افزودن مورد",
    "pbb-move-up": "انتقال به بالا",
    "pbb-move-down": "انتقال به پایین",
    "pbb-brief-preview": "پیش‌نمایش Product Brief",
    "pbb-preview-incomplete": "بخش‌های خالی با عنوان تکمیل نشده نمایش داده می‌شوند.",
    "pbb-prompt-preview": "پیش‌نمایش Prompt نهایی",
    "pbb-prompt-preview-description": "متن آماده Copy برای Codex.",
    "pbb-copy-brief": "کپی برگه محصول",
    "pbb-copy-prompt": "کپی Prompt",
    "pbb-download-word": "دانلود فایل Word",
    "pbb-save-draft": "ذخیره Draft",
    "pbb-clear-draft": "پاک‌کردن Draft",
    "pbb-load-meeting-example": "بارگذاری مثال: جلسات پروژه",
    "pbb-draft-local": "ذخیره فقط در مرورگر",
    "pbb-last-save": "آخرین ذخیره: {{TIME}}",
    "pbb-storage-unavailable": "Local Storage در دسترس نیست",
    "pbb-storage-unavailable-description": "مرورگر اجازه ذخیره Draft را نمی‌دهد؛ اطلاعات فقط تا زمان باز بودن صفحه باقی می‌ماند.",
    "pbb-draft-restored": "Draft قبلی بازیابی شد",
    "pbb-draft-saved": "Draft ذخیره شد",
    "pbb-draft-cleared": "Draft پاک شد",
    "pbb-clear-confirm": "Draft فعلی پاک شود؟",
    "pbb-example-loaded": "مثال جلسات پروژه بارگذاری شد",
    "pbb-copy-success": "متن کپی شد",
    "pbb-copy-error": "کپی متن ناموفق بود",
    "pbb-export-success": "فایل Word ساخته شد",
    "pbb-export-error": "ساخت فایل Word ناموفق بود",
    "pbb-strapi-prompt-preview": "پیش‌نمایش Prompt بک‌اند Strapi",
    "pbb-strapi-prompt-preview-description": "برگه محصول و دستور کار آماده برای اعمال تغییرات لازم در Strapi.",
    "pbb-copy-strapi-prompt": "کپی Prompt بک‌اند",
    "pbb-cancel": "لغو",
    "pbb-export-json": "خروجی JSON",
    "pbb-import-json": "ورود JSON",
    "pbb-json-export-success": "فایل JSON ساخته شد",
    "pbb-json-export-error": "ساخت فایل JSON ناموفق بود",
    "pbb-json-import-success": "فایل JSON وارد شد",
    "pbb-json-import-file-type": "فقط فایل JSON معتبر قابل ورود است.",
    "pbb-json-import-read-error": "خواندن فایل JSON ناموفق بود.",
    "pbb-json-import-invalid-json": "محتوای فایل JSON معتبر نیست.",
    "pbb-json-import-invalid-format": "ساختار فایل واردشده معتبر نیست.",
    "pbb-json-import-invalid-type": "این فایل برای Product Brief Builder زوفینو نیست.",
    "pbb-json-import-invalid-version": "نسخه فایل JSON با نسخه فعلی سازنده برگه محصول سازگار نیست.",
    "pbb-json-import-missing-brief": "بخش brief در فایل JSON پیدا نشد.",
    "pbb-json-import-confirm-title": "ورود JSON",
    "pbb-json-import-confirm-description": "با تایید، اطلاعات فعلی فرم با محتوای فایل JSON جایگزین می‌شود.",
    "pbb-json-import-confirm-accept": "جایگزینی فرم",
    "pbb-ai-open": "تکمیل با هوش مصنوعی",
    "pbb-ai-dialog-title": "تکمیل برگه محصول با هوش مصنوعی",
    "pbb-ai-dialog-description": "توضیح خام درخواست را وارد کنید تا هوش مصنوعی برگه محصول را به‌صورت ساختاریافته تکمیل کند.",
    "pbb-ai-input-label": "توضیح خام درخواست",
    "pbb-ai-input-placeholder": "مثلاً کاربر چه مشکلی دارد، این تغییر کجا دیده می‌شود و نتیجه مورد انتظار چیست؟",
    "pbb-ai-use-current-brief": "از اطلاعات فعلی فرم به‌عنوان زمینه استفاده کن",
    "pbb-ai-submit": "تحلیل و تکمیل فرم",
    "pbb-ai-loading": "در حال تحلیل درخواست...",
    "pbb-ai-apply": "اعمال اطلاعات در فرم",
    "pbb-ai-apply-success": "اطلاعات هوش مصنوعی در فرم اعمال شد",
    "pbb-ai-result-ready": "خروجی آماده اعمال است",
    "pbb-ai-result-ready-description": "برگه محصول ساختاریافته آماده است.",
    "pbb-ai-raw-response": "پاسخ خام هوش مصنوعی",
    "pbb-ai-no-workspace": "برای استفاده از هوش مصنوعی باید Workspace فعال وجود داشته باشد.",
    "pbb-ai-error-no-workspace": "Workspace فعال پیدا نشد؛ درخواست ارسال نشد.",
    "pbb-ai-error-400": "درخواست ارسال‌شده برای هوش مصنوعی معتبر نیست.",
    "pbb-ai-error-401": "برای استفاده از هوش مصنوعی باید دوباره وارد حساب شوید.",
    "pbb-ai-error-403": "شما اجازه استفاده از هوش مصنوعی در این Workspace را ندارید.",
    "pbb-ai-error-429": "تعداد درخواست‌های هوش مصنوعی زیاد شده است. کمی بعد دوباره تلاش کنید.",
    "pbb-ai-error-502": "سرویس هوش مصنوعی در حال حاضر پاسخ مناسب نداد.",
    "pbb-ai-error-generic": "ارتباط با هوش مصنوعی ناموفق بود.",
    "pbb-ai-parse-invalid-json": "پاسخ هوش مصنوعی JSON معتبر نبود.",
    "pbb-ai-parse-invalid-schema": "ساختار پاسخ هوش مصنوعی با فرم سازگار نیست.",
    "pbb-ai-parse-missing-keys": "پاسخ هوش مصنوعی بعضی فیلدهای ضروری را ندارد.",
    "pbb-ai-parse-invalid-enum": "پاسخ هوش مصنوعی مقدار نامعتبر برای یکی از گزینه‌های ثابت دارد.",
};

export function createProductBriefTranslator(baseTranslate) {
    return (key) => translations[key] || baseTranslate(key);
}
